"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var helpers_1 = require("../../utils/helpers");

var components_1 = require("@lsg/components");

var ErrorBoundary =
/** @class */
function (_super) {
  __extends(ErrorBoundary, _super);

  function ErrorBoundary(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.errorHandler = props.errorHandler || props.context && props.context.errorBoundary && props.context.errorBoundary.errorHandler || console.error;
    return _this;
  }

  ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
    this.errorHandler(error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  };

  ErrorBoundary.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        config = _c.config,
        FallbackComponent = _c.fallbackComponent;

    if (this.state.error) {
      var showFallbackComponent = (_b = (_a = config) === null || _a === void 0 ? void 0 : _a.showFallbackComponent, _b !== null && _b !== void 0 ? _b : true);
      var _d = this.state,
          error = _d.error,
          errorInfo = _d.errorInfo;
      return FallbackComponent ? react_1["default"].createElement(FallbackComponent, {
        error: error,
        errorInfo: errorInfo
      }) : showFallbackComponent ? react_1["default"].createElement(DefaultFallback, {
        error: error,
        errorInfo: errorInfo
      }) : null;
    }

    return this.props.children;
  };

  return ErrorBoundary;
}(react_1["default"].Component);

exports.ErrorBoundary = ErrorBoundary;

var DefaultFallback = function DefaultFallback(_a) {
  var error = _a.error,
      errorInfo = _a.errorInfo;

  var _b, _c;

  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(components_1.Picture, {
    src: "data:image/svg+xml;base64,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",
    maxWidth: 400,
    style: {
      margin: 'auto'
    }
  }), react_1["default"].createElement(components_1.H2, null, "Oops: Hier ist etwas schief gegangen."), react_1["default"].createElement(components_1.Paragraph, null, react_1["default"].createElement("details", {
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, (_b = error) === null || _b === void 0 ? void 0 : _b.toString(), react_1["default"].createElement("br", null), (_c = errorInfo) === null || _c === void 0 ? void 0 : _c.componentStack)));
};

exports.ErrorBoundaryWithContext = function (_a) {
  var children = _a.children,
      config = _a.config,
      errorHandler = _a.errorHandler,
      fallbackComponent = _a.fallbackComponent;
  return react_1["default"].createElement(helpers_1.ErrorBoundaryContext.Consumer, null, function (context) {
    return react_1["default"].createElement(ErrorBoundary, {
      config: config,
      context: context,
      errorHandler: errorHandler,
      fallbackComponent: fallbackComponent
    }, children);
  });
};

exports.withErrorBoundary = function (WrappedComponent, config) {
  return (
    /** @class */
    function (_super) {
      __extends(class_1, _super);

      function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
      }

      class_1.prototype.render = function () {
        var _a;

        var _b = this.props,
            errorHandler = _b.errorHandler,
            fallbackComponent = _b.fallbackComponent,
            props = __rest(_b, ["errorHandler", "fallbackComponent"]);

        var withContext = (_a = config) === null || _a === void 0 ? void 0 : _a.withContext;
        return withContext ? react_1["default"].createElement(exports.ErrorBoundaryWithContext, {
          config: config,
          errorHandler: errorHandler,
          fallbackComponent: fallbackComponent
        }, react_1["default"].createElement(WrappedComponent, __assign({}, props))) : react_1["default"].createElement(ErrorBoundary, {
          config: config,
          errorHandler: errorHandler,
          fallbackComponent: fallbackComponent
        }, react_1["default"].createElement(WrappedComponent, __assign({}, props)));
      };

      return class_1;
    }(react_1["default"].Component)
  );
};